import { AnyType } from './common-types';

const tasks: AnyType[] = [];

export interface ProjectKanbanColumn {
  column: string;
  steps: { step_name: string }[];
  tasks: AnyType[];
  total: number;
}

export const KanbanConfig: ProjectKanbanColumn[] = [
  {
    column: 'Draft',
    steps: [
      {
        step_name: 'Draft',
      },
      {
        step_name: 'Task saved',
      },
    ],
    tasks: tasks,
    total: 0,
  },
  {
    column: 'Requires attention',
    steps: [
      {
        step_name: 'QA failed',
      },
      {
        step_name: 'Booking',
      },
      {
        step_name: 'Open unassigned',
      },
      {
        step_name: 'Open unassigned studio',
      },
      {
        step_name: 'Open assigned',
      },
      {
        step_name: 'Open assigned CGI',
      },
      {
        step_name: 'Review briefing',
      },
      {
        step_name: 'Questions',
      },
      {
        step_name: 'Question',
      },
      {
        step_name: 'Change requested',
      },
      {
        step_name: 'Task submitted',
      },
      {
        step_name: 'Task assigned',
      },
      {
        step_name: 'Task can be invoiced',
      },
      {
        step_name: 'Assigned to QA',
      },
      {
        step_name: 'QA passed',
      },
      {
        step_name: 'Briefing incomplete',
      },
      {
        step_name: 'Feedback required',
      },
      {
        step_name: 'Feedback incomplete',
      },
      {
        step_name: 'Feedback',
      },
      {
        step_name: 'Client feedback required',
      },
      {
        step_name: 'Client briefing incomplete',
      },
      {
        step_name: 'Publish to DAM',
      },
      {
        step_name: 'Check briefing',
      },
      {
        step_name: 'Client feedback incomplete',
      },
      {
        step_name: 'Rejection feedback incomplete',
      },
      {
        step_name: 'Feedback required kreation',
      },
      {
        step_name: 'Convert final data',
      },
      {
        step_name: 'Final data',
      },
      {
        step_name: 'Client delivery final data',
      },
      {
        step_name: 'Client delivery final data',
      },
      {
        step_name: 'Info required',
      },
      {
        step_name: 'Deployed to DEV',
      },
      {
        step_name: 'Approved for deploy to LIVE',
      },
      {
        step_name: 'Deployed to LIVE',
      },
      {
        step_name: 'Assign to QA',
      },
      {
        step_name: 'Rejected by agency assigned',
      },
      {
        step_name: 'Rejection feedback required',
      },
      {
        step_name: 'Agency feedback required',
      },
      {
        step_name: 'Approved by agency',
      },
      {
        step_name: 'Upload to adserver',
      },
      {
        step_name: 'Check adserver link internally',
      },
      {
        step_name: 'Check adserver link agency',
      },
      {
        step_name: 'Create CGI final',
      },
      {
        step_name: 'CGI final',
      },
      {
        step_name: 'Submitted to client',
      },
      {
        step_name: 'Rejected unassigned',
      },
    ],
    tasks: tasks,
    total: 0,
  },
  {
    column: 'WIP',
    steps: [
      {
        step_name: 'Task in analysis',
      },
      {
        step_name: 'Work in progress',
      },
      {
        step_name: 'Task in progress',
      },
      {
        step_name: 'Sub-task in-progress',
      },
      {
        step_name: 'Re-work client correction',
      },
      {
        step_name: 'Re-work client rejection',
      },
      {
        step_name: 'Internal re-work',
      },
      {
        step_name: 'WIP Artists',
      },
      {
        step_name: 'CGI WIP',
      },
      {
        step_name: 'Re-work CGI',
      },
      {
        step_name: 'Re-work',
      },
      {
        step_name: 'WIP Editor',
      },
      {
        step_name: 'Re-work artist',
      },
      {
        step_name: 'Re-work editor',
      },
      {
        step_name: 'Re-work client rejection artist',
      },
      {
        step_name: 'Re-work client rejection editor',
      },
      {
        step_name: 'Edit step',
      },
      {
        step_name: 'Booked',
      },
      {
        step_name: 'Re-work agency correction',
      },
    ],
    tasks: tasks,
    total: 0,
  },
  {
    column: 'Awaiting approval',
    steps: [
      {
        step_name: 'Awaiting approval',
      },
      {
        step_name: 'Internal Approval',
      },
      {
        step_name: 'Estimate submitted',
      },
      {
        step_name: 'Ready for QA',
      },
      {
        step_name: 'Sent to client for approval',
      },
      {
        step_name: 'Awaiting client approval',
      },
      {
        step_name: 'Awaiting internal approval',
      },
      {
        step_name: 'Review & approval',
      },
      {
        step_name: 'Change request approval',
      },
      {
        step_name: 'CD approval',
      },
      {
        step_name: 'Awaiting internal approval Kreation',
      },
      {
        step_name: 'Awaiting agency approval',
      },
      {
        step_name: 'Awaiting Mat_Geo approval',
      },
      {
        step_name: 'Awaiting studio approval',
      },
    ],
    tasks: tasks,
    total: 0,
  },
  {
    column: 'Approved',
    steps: [
      {
        step_name: 'Approved',
      },
      {
        step_name: 'Approved by client',
      },
      {
        step_name: 'Approved by kreation',
      },
      {
        step_name: 'Final data upload',
      },
      {
        step_name: 'Final data download',
      },
      {
        step_name: 'Final data downloaded',
      },
      {
        step_name: 'Final data available',
      },
      {
        step_name: 'Studio approved',
      },
    ],
    tasks: tasks,
    total: 0,
  },
  {
    column: 'Rejected',
    steps: [
      {
        step_name: 'Rejected',
      },
      {
        step_name: 'Internally rejected',
      },
      {
        step_name: 'Internally rejected unassigned',
      },
      {
        step_name: 'Internally rejected assigned',
      },
      {
        step_name: 'Rejected assigned',
      },
      {
        step_name: 'Rejected assigned CGI',
      },
      {
        step_name: 'Internally rejected editor',
      },
      {
        step_name: 'Estimate rejected',
      },
      {
        step_name: 'Rejected by client',
      },
      {
        step_name: 'Rejected by Kreation',
      },
      {
        step_name: 'Rejected by client unassigned',
      },
      {
        step_name: 'Rejected by client assigned',
      },
      {
        step_name: 'Rejected by client editor',
      },
      {
        step_name: 'QA failed',
      },
      {
        step_name: 'Rejected by agency',
      },
    ],
    tasks: tasks,
    total: 0,
  },
  {
    column: 'On hold',
    steps: [
      {
        step_name: 'Task on hold',
      },
    ],
    tasks: tasks,
    total: 0,
  },
  {
    column: 'Closed',
    steps: [
      {
        step_name: 'Task closed',
      },
    ],
    tasks: tasks,
    total: 0,
  },
];
